import { CampaignStatus } from "@/types/campaign/campaign-status/campaign-status";

export const STATUS_MESSAGES: Record<CampaignStatus, string> = {
    comingUp: 'Comienza en',
    inCourse: 'En curso',
    completed: '¡Misión cumplida!',
    expired: 'Expirada',
    pending_claim: '¡Redime tu recompensa!',
    incourseWinning: 'En curso',
    incourseLoosing: 'En curso',
};

export const CAMPAIGN_COMPLETED_MESSAGE = '¡Cumplida!';